import i18next from 'i18next';
import { cropperEmpregare } from './cropper';
import { carregarSelect2 } from './carregarSelect2';
import { CURRICULO_TIPO, _URL_FORM, abrirFormCadastro, fecharFormCadastro } from './helpers';
import { buscaCep } from '../../utilidades/buscaCep';
import { janelaAjuda } from './janelaAjuda';
import { loadMetodosIniciais } from './loadMetodosIniciais';
import { progressoCurriculo } from './progresso';

export const dadosPessoais = function (loadInicial) {
    "use strict";
    var $divPanel = '#panel-pessoais';
    var $panel = body.find($divPanel);
    var cropperInstancia = null;

    var _excluirFoto = function () {
        swal({
            title: i18next.t('fotoRemoverTitle'),
            html: i18next.t('fotoRemoverDescricao'),
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: i18next.t('btnSimRemover'),
            cancelButtonText: i18next.t('btnCancelar'),
            closeOnConfirm: true
        }, function () {

            //window.global.loaderPanel.show($divPanel);
            window.global.loaderFull.show();
            var sexo = $panel.find('#pessoais-lista').find('h3');
            $.ajax({
                type: "GET",
                url: '/' + CULTURE_EMPREGARE + '/PainelCurriculoAntigo/DeleteFoto?sexo=' + sexo.attr('data-sexo'), cache: false,
                success: function (data) {
                    if (data.success == 1) {

                        body.find('.avatar-view').find('img').attr('src', data.foto);
                        $panel.find('#btn-adicionar-foto').removeClass('hide');
                        $panel.find('#btn-editar-foto').addClass('hide');
                        toastr.success(i18next.t('fotoRemovidaSucesso'), '', { "closeButton": true });
                        progressoCurriculo();
                    } else {
                        swal("", data.error, "error");
                    }
                    window.global.loaderFull.hide();
                    //window.global.loaderPanel.hide($divPanel);
                },
                error: function () {
                    window.global.loaderFull.hide();
                    //window.global.loaderPanel.hide($divPanel);
                    swal("", i18next.t('erroServidor'), "error");
                }
            });
        });

    };
    var _addZeroEsquerda = function (str) {

        if (str.length == 1) {
            return '0' + str;
        }
        return str;
    };

    var _listar = function () {

        window.global.loaderPanel.show($divPanel);

        $.ajax({
            type: "GET",
            url: '/' + CULTURE_EMPREGARE + '/PainelCurriculoAntigo/GetDadosPessoais', cache: false,
            success: function (dados) {
                var html = [], item = '', enderecoIncompleto = '', estadoCivilIncompleto = '', oQueFaltaEndereco = '', faltouDadosEndereco = 0;
                if (dados != '') {
                    if (dados.arquivoCurriculo != '') {
                        // O nome salvo e "{pessoaID}-{data}-{guid}.ext" (nao o original): so a extensao
                        // ajuda o candidato a reconhecer o que enviou, entao e o unico pedaco exibido.
                        var posPonto = dados.arquivoCurriculo.lastIndexOf('.');
                        $('#cv-anexado-formato').text(posPonto > -1 ? dados.arquivoCurriculo.slice(posPonto + 1).toUpperCase() : '');
                        $('#row-anexar-curriculo').hide();
                        $('#row-baixar-curriculo').show();
                    } else {
                        $('#row-anexar-curriculo').show();
                        $('#row-baixar-curriculo').hide();
                    }
                    if (dados.estadoCivil == '')
                        estadoCivilIncompleto = '<span class="alert alert-sm alert-warning container-estadoCivil cursor-pointer btn-add"><i class="fa fa-exclamation-circle"></i> ' + i18next.t('pessoaisEstadoCivil') + '</span> ';
                    else
                        estadoCivilIncompleto = dados.estadoCivil + ', ';
                    html.push('<h3 class="text-primary mt0" data-nome="' + dados.nome + '" data-dia="' + dados.dia + '" data-mes="' + dados.mes + '" data-ano="' + dados.ano + '" data-sexo="' + dados.sexo + '" data-email="' + dados.email + '" data-telefone="' + dados.telefone + '" data-telefonePaisCode="' + dados.telefonePaisCode + '" data-celular="' + dados.celular + '" data-celularPaisCode="' + dados.celularPaisCode + '" data-estadoCivil="' + (dados.estadoCivilID == '0' ? '' : dados.estadoCivilID) + '" data-cidadeID="' + dados.cidadeID + '" data-paisID="' + dados.paisID + '" data-estadoID="' + dados.estadoID + '" data-cep="' + dados.cep + '" data-logradouro="' + dados.logradouro + '" data-bairro="' + dados.bairro + '"><b>' + dados.nome + '</b>');
                    html.push('<button type="button" class="btn btn-primary noborder nopadding pull-right outline btn-add"><i class="fa fa-edit mr5"></i> ' + i18next.t('btnEditarCamelCase') + '</button></h3>');
                    html.push('<p>' + estadoCivilIncompleto + '<span class="container-dataNascimento">' + _addZeroEsquerda(dados.dia + '') + '/' + _addZeroEsquerda(dados.mes + '') + '/' + dados.ano + ' (' + dados.idade + ' ' + i18next.t('pessoaisAno') + ')</span></p>');

                    if (dados.cidadeID != null) {
                        if (dados.logradouro == '') {
                            faltouDadosEndereco = 1;
                            oQueFaltaEndereco = '<b>' + i18next.t('pessoaisLogradouroNull') + '</b>, ';
                        }
                        if (dados.bairro == '') {
                            faltouDadosEndereco = 1;
                            oQueFaltaEndereco += '<b>' + i18next.t('pessoaisBairroNull') + '</b>, ';
                        }
                        if (dados.cep == '') {
                            faltouDadosEndereco = 1;
                            oQueFaltaEndereco += '<b>' + i18next.t('pessoaisCepNull') + '</b>';
                        }
                        if (faltouDadosEndereco == 1)
                            enderecoIncompleto = '<p><span class="alert alert-sm alert-warning cursor-pointer btn-add"><i class="fa fa-exclamation-circle"></i> ' + i18next.t('pessoaisEnderecoIncompleto') + ': ' + oQueFaltaEndereco + '</span></p>';

                        html.push(enderecoIncompleto + '<p><i class="fa fa-map-marker"></i> ' + dados.cidade + ', ' + dados.estado + ', ' + dados.paisID + '<br />');
                        if (dados.logradouro != '' || dados.bairro != '' || dados.cep != '') {
                            html.push((dados.logradouro != '' ? (dados.logradouro + ' - ') : '') + dados.bairro + (dados.cep != '' ? (' - ' + dados.cep) : ''));
                        }
                        html.push('</p>');
                    } else {
                        html.push('<p><span class="alert alert-sm alert-warning cursor-pointer btn-add"><i class="fa fa-exclamation-circle"></i> ' + i18next.t('pessoaisInformeEndereco') + '</span></p>');
                    }
                    if (dados.telefone != '' || dados.celular != '') {
                        if (!isNullOrEmpty(dados.celular)) {
                            html.push('<p><i class="fa fa-phone"></i> ' + dados.celularPaisCode + ' ' + dados.celular + '</p>');
                        }
                        if (!isNullOrEmpty(dados.telefone)) {
                            html.push('<p><i class="fa fa-phone"></i> ' + dados.telefonePaisCode + ' ' + dados.telefone + '</p>');
                        }
                    } else {
                        html.push('<p><span class="alert alert-sm alert-warning cursor-pointer btn-add"><i class="fa fa-exclamation-circle"></i> ' + i18next.t('pessoaisInformeTelefone') + '</span></p>');
                    }
                    html.push('<p><i class="fa fa-comment"></i> ' + dados.email + '</p>');
                    $panel.find('.avatar-view').find('img').attr('src', dados.foto);

                    if (dados.possuiFoto) {
                        $panel.find('#btn-adicionar-foto').addClass('hide');
                        $panel.find('#btn-editar-foto').removeClass('hide');
                    } else {
                        $panel.find('#btn-adicionar-foto').removeClass('hide');
                        $panel.find('#btn-editar-foto').addClass('hide');
                    }

                    if (loadInicial) {
                        $panel.find('#btn-remover-foto').on('click', function (e) {
                            _excluirFoto();
                            e.preventDefault();
                        });
                        loadMetodosIniciais(dados, $panel);
                    }

                    document.getElementById('pessoais-lista').innerHTML = html.join('');
                    $panel.find('.btn-add').on('click', function (e) {
                        _abrir();
                        e.preventDefault();
                    });
                } else {
                    return window.location.href = '/' + CULTURE_EMPREGARE + '/login?tipo=candidato&ReturnUrl=/candidato/curriculo';
                }


                window.global.loaderPanel.hide($divPanel);

            },
            error: function () {
                window.global.loaderPanel.hide($divPanel);
            }
        });
    };
    var _salvar = function () {
        var $form = $panel.find('#form-pessoais');

        if ($form.find('#celular').intlTelInput("getSelectedCountryData").dialCode == '55') {
            const tamanho = $form.find('#celular').val().length;

            if (tamanho > 0 && tamanho < 14) {
                toastr.error(i18next.t('validacaoCelularIncompleto'), '', { "closeButton": true });
                return;
            }
        };

        if ($form.find('#telefone').intlTelInput("getSelectedCountryData").dialCode == '55') {
            const tamanho = $form.find('#telefone').val().length;

            if (tamanho > 0 && tamanho < 14) {

                toastr.error(i18next.t('validacaoTelefoneIncompleto'), '', { "closeButton": true });
                return;
            }
        };

        window.global.loaderButton.show($form.find('button[type=submit]'));
        var $tipoCurriculo = CURRICULO_TIPO();
        $.ajax({
            type: "POST",
            url: '/' + CULTURE_EMPREGARE + '/PainelCurriculoAntigo/SaveDadosPessoais', cache: false,
            data: $form.serialize() + '&tipoCurriculo=' + $tipoCurriculo
                + '&telefonePaisCode=' + $form.find('#telefone').intlTelInput("getSelectedCountryData").dialCode
                + '&celularPaisCode=' + $form.find('#celular').intlTelInput("getSelectedCountryData").dialCode,
            success: function (data) {
                if (data.success == 1) {
                    toastr.success(i18next.t('pessoaisSucesso'), '', { "closeButton": true });
                    dadosPessoais(false);
                    progressoCurriculo();
                    _fechar();
                }
                else {
                    swal("", data.error, "error");
                    window.global.loaderButton.hide($form.find('button[type=submit]'));
                }

            },
            error: function () {
                window.global.loaderButton.hide($form.find('button[type=submit]'));
                swal("", i18next.t('erroServidor'), "error");
            }
        });
    };
    var _fechar = function () {
        document.getElementById('pessoais-contentform').innerHTML = '';
        goToByScroll($divPanel);
        fecharFormCadastro();
    };

    var _abrir = function () {
        goToByScroll($divPanel);
        window.global.loaderFull.show();
        //window.global.loaderPanel.show($divPanel);
        var formulario = $panel.find('#pessoais-contentform');


        abrirFormCadastro();
        formulario.load(_URL_FORM + "DadosPessoais?v=2", function () {
            $.validate({
                form: '#form-pessoais',
            });

            formulario.find('.close-panel').on('click', function (e) {
                _fechar();
                e.preventDefault();
            });
            formulario.find('#form-pessoais').on('submit', function (e) {
                if ($(this).isValid()) {
                    _salvar();
                }
                e.preventDefault();
            });

            var dados = $panel.find('#pessoais-lista').find('h3');

            formulario.find('#nome').val(dados.attr('data-nome'));
            formulario.find('#nascimento-dia').val(dados.attr('data-dia'));
            formulario.find('#nascimento-mes').val(dados.attr('data-mes'));
            formulario.find('#nascimento-ano').val(dados.attr('data-ano'));
            formulario.find('#email').val(dados.attr('data-email'));
            formulario.find("#Sexo").val(dados.attr('data-sexo'));

            formulario.find('#telefone').val((dados.attr('data-telefonePaisCode') + " " + dados.attr('data-telefone')));
            formulario.find('#celular').val((dados.attr('data-celularPaisCode') + " " + dados.attr('data-celular')));

            formulario.find('#estado-civil').val(dados.attr('data-estadoCivil'));

            formulario.find('#cep').val(dados.attr('data-cep'));
            formulario.find('#logradouro').val(dados.attr('data-logradouro'));
            formulario.find('#bairro').val(dados.attr('data-bairro'));


            formulario.find('#paisID').val(dados.attr('data-paisID'));

            function addMaskOnCep() {
                if (formulario.find('#paisID').val() === 'BR') {
                    formulario.find('#cep').mask('00000-000').attr('placeholder', '00000-000');
                } else {
                    formulario.find('#cep').unmask().removeAttr('placeholder');
                }
            }
            addMaskOnCep();

            formulario.find('#paisID').on('change', function () {
                addMaskOnCep();
                $(this).trigger('blur');

                formulario.find('#estadoID').html('<option value="">' + i18next.t('pessoaisSelectPais') + '</option>').trigger('change').trigger('blur');
            });

            formulario.find('#estadoID').on('change', function () {
                formulario.find('#cidadeID').html('<option value="">' + i18next.t('pessoaisSelectEstado') + '</option>').trigger('change').trigger('blur');
            });

            formulario.find('#paisID, #estadoID').on('change', function () {
                var $this = $(this);
                var url = $this.attr('data-api');
                var id = $this.val();
                var $element = $('#' + $this.attr('data-element'));

                if (url == 'estados') {
                    $('#cidadeID').html('<option value="">' + i18next.t('pessoaisSelectEstado') + '</option>').trigger('change').trigger('blur');
                }

                carregarSelect2().then(function () {
                    window.global.localidades.obterCombos(url, id, $element, '', true);
                });

                $this.trigger('blur');
            });

            formulario.find('#estadoID, #cidadeID').on('change', function () {
                $(this).trigger('blur');
            });

            carregarSelect2().then(function () {
                formulario.find('#paisID').select2();
                window.global.localidades.obterCombos('estados', dados.attr('data-paisID'), $('#estadoID'), dados.attr('data-estadoID'), true);
                window.global.localidades.obterCombos('cidades', dados.attr('data-estadoID'), $('#cidadeID'), dados.attr('data-cidadeID'), true);

                // Preenchimento automatico pelo CEP. Registrado aqui, e nao antes, para nao correr com a carga
                // inicial dos combos acima: se o CEP resolvesse primeiro, a carga inicial responderia depois e
                // repintaria o estado ANTIGO ao lado da cidade NOVA, sem nenhum dos dois campos parecer invalido.
                // Gatilho 'input' (nao 'blur'/'change') porque colar o CEP sem tirar o foco nao dispara nenhum
                // dos dois; o dedupe evita repetir a busca a cada tecla digitada.
                let ultimoCepBuscado = '';
                formulario.find('#cep').on('input', async function () {
                    const digitos = this.value.replace(/\D/g, '');

                    if (formulario.find('#paisID').val() !== 'BR' || digitos.length !== 8 || digitos === ultimoCepBuscado)
                        return;

                    ultimoCepBuscado = digitos;

                    // try/catch porque o await rejeita quando a rede cai: sem ele vira unhandled rejection
                    // (o jQuery descarta o retorno do handler) e o CEP fica queimado no dedupe.
                    let dadosCep;
                    try {
                        dadosCep = await buscaCep(this.value, formulario[0]);
                    } catch {
                        ultimoCepBuscado = '';
                        return;
                    }

                    if (!dadosCep || !dadosCep.cidadeID) {
                        // Libera a retentativa: sem isso uma falha de rede deixaria esse CEP sem autopreenchimento
                        // ate o painel ser reaberto, porque redigitar o mesmo valor bateria no dedupe.
                        ultimoCepBuscado = '';
                        return;
                    }

                    // obterCombos nos DOIS selects (em vez de .val() no estado): ele repopula ja marcando o
                    // selected, entao acerta mesmo que a option do estado ainda nao exista. Um .val() puro
                    // encontraria o select vazio e deixaria o estado em branco com a cidade preenchida.
                    window.global.localidades.obterCombos('estados', formulario.find('#paisID').val(), formulario.find('#estadoID'), dadosCep.estadoID, true);
                    window.global.localidades.obterCombos('cidades', dadosCep.estadoID, formulario.find('#cidadeID'), dadosCep.cidadeID, true);
                });
            });

            const opcoesIntlInput = {
                initialCountry: 'auto',
                hiddenInput: "full_phone",
                formatOnDisplay: false,
                preferredCountries: ['br', 'cl', 'ar', 'es', 'pt', 'us', 'fr'],
                utilsScript: "/assets/lib/intl-tel-input/js/utils.js"
            };

            formulario.find("#celular, #telefone").intlTelInput(opcoesIntlInput);

            if ((dados.attr('data-telefonePaisCode') + dados.attr('data-telefone')) == '') {
                $("#telefone").val('');
                $("#telefone").intlTelInput("setCountry", "BR");
            }

            if ((dados.attr('data-celularPaisCode') + dados.attr('data-celular')) == '') {
                $("#celular").val('');
                $("#celular").intlTelInput("setCountry", "BR");
            }

            const SPMaskBehavior = function (val) {
                return val.replace(/\D/g, '').length >= 11 ? '(00) 00000-0000' : '(00) 0000-00009';
            }
            const addMaskById = function (elementId) {
                const inputField = formulario.find(elementId);
                const initDialCode = inputField.intlTelInput("getSelectedCountryData").dialCode;
                const brasilDialCode = '55';

                const options = {
                    onKeyPress: function (number, e, field, options) {
                        inputField.mask(SPMaskBehavior, options);
                    }
                };

                while (inputField.val().includes('+')) {
                    let inputString = inputField.val();

                    let indexOfSpace = inputString.indexOf(" ");

                    if (indexOfSpace !== -1) {
                        let trimmedString = inputString.substring(indexOfSpace + 1);
                        inputField.val(trimmedString)
                    }
                }

                if (brasilDialCode == initDialCode) {
                    inputField.mask(SPMaskBehavior, options);
                }

                inputField.on("countrychange", function (e, countryData) {

                    if (brasilDialCode == countryData.dialCode) {
                        $(elementId).unmask();
                        inputField.mask(SPMaskBehavior, options);
                    }
                    else {
                        $(elementId).unmask();
                    }
                });
            };

            addMaskById("#celular");
            addMaskById("#telefone");

            janelaAjuda(formulario);

            setTimeout(() => {
                window.global.loaderFull.hide();
            }, 1000);
            //window.global.loaderPanel.hide($divPanel);
        });


    };

    const _erroFoto = function (msg, selector) {
        $('.avatar-alert').remove();

        const alert =
            `<div class="alert alert-danger avatar-alert alert-dismissable">
                <button type="button" class="close" data-dismiss="alert">&times;</button>
                ${msg}
            </div>`;

        $(selector).after(alert);
    }

    const _tratarFotoEnviada = function (event) {
        $('#avatar-modal').find('.avatar-save').prop('disabled', true);
        // limpa erro anterior ao escolher novo arquivo (senao um erro fica sobre um preview valido)
        $('.avatar-alert').remove();

        const retorno = cropperEmpregare.validarImagemEnviada(event);

        if (!retorno) {
            _erroFoto(i18next.t('envioFotoArquivoInvalido'), '.avatar-upload')
            return;
        }

        const { file, imageURL } = retorno;

        const MAX_FILE_SIZE = 10 * 1024 * 1024;
        if (file.size > MAX_FILE_SIZE) {
            _erroFoto(i18next.t('envioFotoTamanhoInvalido'), '.avatar-upload');
            return;
        }

        const $avatarModal = $('#avatar-modal');
        const $avatarViewImg = $('.avatar-view').find('img');
        const $avatarForm = $avatarModal.find('.avatar-form');
        const $hideOnCrop = $avatarModal.find('.hide-on-crop');
        const $hideOnNull = $avatarModal.find('.hide-on-null');
        const imgInput = document.getElementById('avatarInput');
        const imagem = document.getElementById('imagem-foto-candidato');

        imagem.src = imageURL;

        $hideOnCrop.addClass('hide');
        $hideOnNull.removeClass('hide');

        // destroi o cropper anterior antes de recriar (senao "Carregar outra foto" nao renderiza).
        if (cropperInstancia) {
            cropperInstancia.destroy();
            cropperInstancia = null;
        }

        cropperEmpregare.iniciarCropper(
            function (cropper) {
                cropperInstancia = cropper;
                $avatarModal.find('.btn-cancelar-crop').off('click').on('click', function () {
                    $hideOnCrop.removeClass('hide');
                    $hideOnNull.addClass('hide');
                    cropper.destroy();
                    cropperInstancia = null;
                    imgInput.value = null;
                    $avatarModal.find('.avatar-save').prop('disabled', true);
                });

                $avatarModal.on('hidden.bs.modal', function (e) {
                    cropper.destroy();
                    cropperInstancia = null;
                })
            },
            function (cropper) {
                $avatarModal.find('.avatar-save').prop('disabled', false);
                $avatarForm.off('submit').on('submit', function (event) {
                    event.preventDefault();

                    const data = new FormData($avatarForm[0]);
                    const url = $avatarForm.attr('action');

                    $.ajax(url, {
                        type: 'post',
                        data: data,
                        dataType: 'json',
                        processData: false,
                        contentType: false,
                        beforeSend: function () {
                            window.global.loaderPanel.show('#panel-foto');
                        },
                        success: function (data) {
                            if (data.state == 200 && data.uploaded) {
                                body.find('#btn-adicionar-foto').addClass('hide');
                                body.find('#btn-editar-foto').removeClass('hide');

                                $avatarModal.modal('hide');
                                $avatarViewImg.prop('src', data.result);
                                toastr.success(data.message, '', { "closeButton": true });
                            } else {
                                _erroFoto(data.msg, '.avatar-upload');
                            }
                        },
                        error: function (data) {
                            _erroFoto(data.msg, '.avatar-upload');
                        },
                        complete: function () {
                            window.global.loaderPanel.hide('#panel-foto');
                        }
                    });
                })
            }
        );
    };

    const _eventListenerFoto = function () {
        const $avatarModal = $('#avatar-modal');
        const $avatarViewImg = $('.avatar-view').find('img');
        const $avatarPreview = $avatarModal.find('.avatar-preview');
        const $hideOnCrop = $avatarModal.find('.hide-on-crop');
        const $hideOnNull = $avatarModal.find('.hide-on-null');
        const imgInput = document.getElementById('avatarInput');

        // reset ao (re)abrir: remove erro antigo, limpa arquivo/dados de corte e cropper pendente,
        // e desabilita Salvar ate uma nova imagem valida ser escolhida.
        $('.avatar-alert').remove();
        imgInput.value = null;
        $avatarModal.find('.avatar-data, .avatar-src').val('');
        if (cropperInstancia) {
            cropperInstancia.destroy();
            cropperInstancia = null;
        }
        $avatarModal.find('.avatar-save').prop('disabled', true);

        $avatarModal.modal('show');
        $hideOnNull.addClass('hide');
        $hideOnCrop.removeClass('hide');

        $avatarPreview.html(`<img src="${$avatarViewImg.prop('src')}">`);

        $avatarModal.find('.btn-foto-pc').off('click').on('click', () => {
            imgInput.value = null;
            $(imgInput).trigger('click');
        });

        imgInput.onchange = _tratarFotoEnviada;
    }

    var init = function () {
        _listar();

        $('#btn-adicionar-foto, .avatar-change').on('click', _eventListenerFoto);
    }

    return init();
};

